import { render, staticRenderFns } from "./storehouse.vue?vue&type=template&id=42a5daa0&scoped=true&"
import script from "./storehouse.vue?vue&type=script&lang=ts&"
export * from "./storehouse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a5daa0",
  null
  
)

export default component.exports